let messaages_zh_HK = {
	Salutation: {
		required: 'Please select a salutation.',
	},
	FirstName: {
		required: 'Please enter a first name.',
	},
	LastName: {
		required: 'Please enter a last name.',
	},
	Email: {
		required: 'Please enter an email address.',
		email: 'Please enter a valid email address.',
	},
	Country: {
		required: 'Please select a country.',
	},
	Postcode: {
		required: 'Please select a postcode.',
	},
	Password: {
		required: 'Please enter a password.',
	},
	ConfirmPassword: {
		required: 'Please enter a password to confirm it.',
		equalTo: 'Please ensure that the passwords match.',
	},
	TermsAndConditions: {
		required: 'Please agree to the terms and conditions.',
	}
};

export function messages_zh_HK() {
	return messaages_zh_HK;
}
